import React from 'react';
import {
  Heading,
  FormikField,
  Flex,
  Text,
  TextInput,
  rem,
} from '@feast-it/pesto';

function SocialMediaLinks() {
  return (
    <Flex alignItems="center" flexDirection="column">
      <Heading
        textAlign="center"
        mb={{ _: 2, m: 4 }}
        color="blueDark"
        fontSize={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
        lineHeight={{
          _: 'headingExtraLargeMobile',
          m: 'headingLargeMobile',
        }}
        fontWeight={500}
      >
        Website and social media links
      </Heading>

      <Text
        color="blueDark"
        textAlign="center"
        mb={4}
        fontFamily="body"
        fontSize={{ _: 'body', m: 'headingMediumMobile' }}
        lineHeight={{ _: 'body', m: 'headingMediumMobile' }}
      >
        We use this information to learn a bit more about your business.
      </Text>

      <Flex mt={9} flexDirection="column" alignItems="center" width="100%">
        <FormikField
          width={{ _: '100%', m: rem(620) }}
          label="Website"
          as={TextInput}
          name="supplier.external_links.website"
          color="blueDark"
          fontFamily="body"
        />

        <FormikField
          width={{ _: '100%', m: rem(620) }}
          mt={4}
          label="Instagram"
          as={TextInput}
          name="supplier.external_links.instagram"
          color="blueDark"
          fontFamily="body"
        />

        <FormikField
          mt={4}
          label="Other (separate multiple links with a comma)"
          as={TextInput}
          width={{ _: '100%', m: rem(620) }}
          name="supplier.external_links.other"
          color="blueDark"
          fontFamily="body"
        />
      </Flex>
    </Flex>
  );
}

export default SocialMediaLinks;
